<template>
  <div>
    <div class="captcha" v-if="!validCaptcha">
      <div class="vertical-center">
        <h2 class="sub-head mt-0">Please verify to access Tracking details</h2>
        <vue-recaptcha
          v-if="siteKey"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          :loadRecaptchaScript="true"
          :sitekey="`${siteKey}`"
          >
        </vue-recaptcha>
      </div>
    </div>
    <div v-else>
      <consignee-trip-details/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import VueRecaptcha from 'vue-recaptcha';
import ConsigneeTripDetails from './ConsigneeTripDetails';

export default {
  data() {
    return {
      validCaptcha: false,
    };
  },
  components: {
    ConsigneeTripDetails,
    VueRecaptcha,
  },
  computed: {
    ...mapGetters({
      environmentVariables: 'app/environmentVariables',
    }),
    siteKey() {
      return this.environmentVariables.rc_site_key;
    },
  },
  methods: {
    async onCaptchaVerified(recaptchaToken) {
      const response = await this.$store.dispatch('track/reCaptchaVerify', recaptchaToken);
      if (!response.data.success) {
        self.$refs.recaptcha.reset();
      } else {
        this.validCaptcha = true;
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>
  <style lang="scss">
  .captcha {
    height: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    .vertical-center {
      width: 345px;
      padding: 20px;
      margin-left: -172px;
      position: absolute;
      top: 48%;
      left: 0;
      border-radius: 4px;
      box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.06);
      transform: translateY(-48%);
    }
  }
  </style>

